module.exports = __webpack_public_path__ + "img/Soldout-M.4f789d0.png";